
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import Warteliste from '@/types/Warteliste';
    import { DataTableHeaders } from '@/types';
    import { DataPagination } from 'vuetify';
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('patient', ['dialogs']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapMutations('patient', ['setDialogWarteliste']),
            ...mapMutations('warteliste', ['setWartelisteItem', 'setEdit']),
        },
    })
    export default class WartelisteDatatable extends Vue {
        @Prop({ default: () => [] }) public items!: Warteliste[];
        @Prop({ default: () => false }) public singleSelect!: boolean;
        @Prop({ default: () => false }) public loading!: boolean;
        @PropSync('selected') public selectedSynced!: Warteliste[];

        public clock: number | undefined = undefined;
        public pagination: DataPagination | null = null;
        public warteliste = new Warteliste();
        public setDialogWarteliste!: (visible: boolean) => void;
        public setWartelisteItem!: (item: Warteliste) => void;
        public setEdit!: (edit: boolean) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<Warteliste> {
            const breakpointWidth = this.$vuetify.breakpoint.width;
            const patientWidth = (breakpointWidth >= 600 && breakpointWidth <= 810) ||
                (breakpointWidth >= 1264 && breakpointWidth <= 1650)
                ? 180
                : undefined;

            return [
                { text: 'Status', value: 'status', sortable: false, width: 125 },
                { text: 'Patient', value: 'patientName', sortable: false, width: patientWidth },
                { text: 'Geburtsdatum', value: 'patientGeburtsdatum', sortable: false },
                { text: 'Geschlecht', value: 'patientGeschlecht', sortable: false },
                { text: '', value: 'folgetermin', sortable: false, width: 5 },
                { text: 'Anmerkungen', value: 'bemerkungen', sortable: false },
                { text: '', value: 'actions', sortable: false, width: 50 },
            ];
        }

        public mounted(): void {
            this.clockTick();
        }

        public destroyed(): void {
            window.clearTimeout(this.clock);
        }

        public clockTick(): void {
            this.items.forEach((item) => item.calcWaitTime());
            this.clock = window.setTimeout(this.clockTick, 1000);
        }

        public onPagination(pagination: DataPagination): void {
            this.pagination = pagination;
        }

        public get itemsPerPage():number {
            if (this.getSystemEinstellung('etikettvariante').value === 'Stemberger') {
                return -1;
            } else {
                return 5;
            }
        }

        public get paginationInfo(): string {
            const itemsLength = this.pagination?.itemsLength;

            if (itemsLength && this.pagination?.itemsPerPage) {
                const pageStart = this.pagination.pageStart + 1;
                const pageStop = itemsLength < this.pagination.pageStop || this.pagination.pageStop < 0
                    ? itemsLength
                    : this.pagination.pageStop;

                return `${pageStart}-${pageStop} von ${itemsLength}`;
            }

            return '–';
        }

        public onClickEdit(item: Warteliste): void {
            this.setEdit(true);
            this.setWartelisteItem(item);
            this.setDialogWarteliste(true);
        }
    }
